import { render, staticRenderFns } from "./SendGoodsDialog.vue?vue&type=template&id=7ba0c43c&scoped=true&"
import script from "./SendGoodsDialog.vue?vue&type=script&lang=ts&"
export * from "./SendGoodsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SendGoodsDialog.vue?vue&type=style&index=0&id=7ba0c43c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba0c43c",
  null
  
)

export default component.exports